import { combineReducers } from "redux"
import eventTypesReducer from "./event-types/event-types-reducers"
import modalReducer from "./modal/modal-reducers"
import productReducer from "./products/products-reducers"
import userReducer from "./user/user-reducer"
import purchasePlanReducer from "./purchasePlan/purchase-plan-reducer"
import apiMappingReducer from "./api-mappings/api-mapping-reducer"
import toastReducer from "./toast/toast-reducer"
import accountsReducer from "./accounts/accounts-reducers"
import invoiceReducer from "./invoice/invoice-reducers"
import webhookReducer from "./webhook/webhook-reducer"
import metricsReducer from "./metrics/metrics-reducer"

const combinedReducer = combineReducers({
  user: userReducer,
  product: productReducer,
  eventTypes: eventTypesReducer,
  modal: modalReducer,
  purchasePlan: purchasePlanReducer,
  apiMapping: apiMappingReducer,
  toast: toastReducer,
  accounts: accountsReducer,
  invoices: invoiceReducer,
  webhook: webhookReducer,
  metrics: metricsReducer
})

export default combinedReducer
